import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParamsComportamientoComercial;

export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteComportamientoComercial extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

   errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            Año: validation.required,
            Desde: validation.required,
            Hasta: validation.required,
        };
    }

    onGenerar = async () => {
        var reporte = await resources.RepComportamientoComercial.Generar(this.state.value);
        kea.download(kea.base64ToBlob(reporte, 'application/vnd.ms-excel'), "Reporte comportamiento comercial.xls");
    }

    render() {
        const getField = this.getField;
        const Number = getField(kea.Number);
        const SucursalSelector = getField(selectores.Sucursal);
        const MesSelector = getField(selectores.Mes);
        return (
            <div>
                <kea.Title titulo="Reporte mensual de comportamiento comercial" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <SucursalSelector field="IdSucursal" label="Sucursal" />,
                    <Number field="Año" label="Año" />,
                    <MesSelector field="Desde" label="Fecha desde" />,
                    <MesSelector field="Hasta" label="Fecha hasta" />,
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportecomportamientocomercial/index.tsx